import { ActivityComponentType } from '@stackflow/react'
import { n_ai_tutor } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
import AITutorStreak from '../../new-portal/ai-tutor/AITutorStreak'
import WebviewStackContainer from '../common/WebviewStackContainer'

const AITutorStreakActivity: ActivityComponentType = () => {
  const { useAITutorFlow } = useAITutorStack()
  const { pop } = useAITutorFlow()

  const { t } = useTranslation()

  return (
    <WebviewStackContainer title={t(n_ai_tutor.menu.subtitle6)} border={false} onBack={pop}>
      <AITutorStreak />
    </WebviewStackContainer>
  )
}

export default AITutorStreakActivity
